<template>
    <div>
        <div class="xinz">
            <div class="right">
                <el-button type="warning" @click="pendingAdds" v-if="canAdd"><i class="fa fa-plus" /> {{$t('m.t_addgoodsadjustment')}}</el-button>
            </div>
        </div>
        <div>
            <el-form :inline="true"  class="demo-form-inline" @keyup.native.enter="getStockAdjustList" size="small">
                <el-form-item label="車號">
                    <el-input placeholder="車號"  v-model="serchCarNumber" clearable>
                    </el-input>
                </el-form-item>
                <el-form-item >
                    <el-date-picker
                            v-model="getFeedDate"
                            type="date"
                            placeholder="選擇日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item >
                    <el-select v-model="serchStatus" placeholder="狀態" style="width:150px;" clearable>
                        <el-option value="0" label="未入倉"></el-option>
                        <el-option value="1" label="已入倉"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getStockAdjustList()"><i class="fa fa-search" /> {{$t('m.b_query')}}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"
                    v-loading="tableloading"
                    @selection-change="handleSelectionChange"
                    :data="stockAdjList"
                    :empty-text="$t('m.t_nodata')"
                    stripe
                    border
                    class="dataListTable">

                <el-table-column
                        prop="itemName"
                        align="left"
                        label="产品">
                </el-table-column>
                <el-table-column
                        prop="qty"
                        align="right"
                        width="90"
                        :label="$t('m.t_qtysk')">
                </el-table-column>
                <el-table-column
                        prop="remark"
                        align="left"
                        :label="$t('m.t_remarks')">
                </el-table-column>
                <el-table-column
                        prop="createDate"
                        align="left"
                        width="110"
                        :label="$t('m.t_date')">
                    <template slot-scope="scope">
                        <template v-if="scope.row.createDate!=0">
                            {{scope.row.createDate*1000 | date('%Y-%m-%d') }}
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="status"
                        align="left"
                        width="90"
                        label="狀態">
                    <template slot-scope="scope">
                        <template v-if="scope.row.status==0">
                            未入倉
                        </template>
                        <template v-if="scope.row.status==1">
                            已入倉
                        </template>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="id"
                        align="center"
                        width="100"
                        :label="$t('m.b_opt')">
                    <template slot-scope="scope" v-if="scope.row.status==0&&(canEdit||canDel||canImport)">
                        <template>
                            <el-dropdown>
                                <el-button size="small" type="primary">
                                    <i class="fa fa-mouse-pointer"/> {{$t('m.b_opt')}}
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item size="small" type="primary" @click.native="pendingEdit(scope.$index, scope.row)" v-if="scope.row.status==0&&canEdit" ><i class="fa fa-edit"/>{{$t('m.b_edit')}}</el-dropdown-item>
                                    <el-dropdown-item  @click.native="importBnt(scope.$index, scope.row)" v-if="scope.row.status==0&&canImport"><i class="fa fa-arrow-right"/> {{$t('m.b_import')}}</el-dropdown-item>
                                    <el-dropdown-item  @click.native="pendingDel(scope.$index, scope.row)"  v-if="scope.row.status==0&&canDel"><i class="fa fa-trash"/> {{$t('m.b_delete')}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination
                    layout="total, prev, pager, next"
                    @current-change="custTaskPageChange"
                    :current-page.sync="pager.page"
                    :page-size="pager.size"
                    :total="pager.total">
            </el-pagination>
        </div>

        <!-- 添加页面多條产品-->
        <el-dialog :title="dialogAddsName" :visible.sync="dialogAddsVisible" width="620px" :close-on-click-modal=false>
            <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"
                    v-loading="tableloading"
                    :data="stockInList"
                    :empty-text="$t('m.t_nodata')"
                    stripe
                    border
                    style="width:100%">
                <el-table-column
                        prop="itemCode"
                        width="148px"
                        align="left"
                        :label="$t('m.b_prodcode')">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.itemId" filterable remote clearable :remote-method="getItemListOption" placeholder=""
                                   style="width:120px;" @focus="getTempIndex(scope.row.index)" @change="itemHandleSelect" default-first-option size="mini">
                            <el-option
                                    v-for="item in scope.row.itemOptions"
                                    :key="item.id"
                                    :label="item.itemName"
                                    :value="item.id">
                                <span style="float: left">{{ item.itemName }}</span>
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="itemName"
                        width="95px"
                        align="left"
                        :label="$t('m.t_qtysk')">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.qty" placeholder=""  auto-complete="off" @focus="getTempIndex(scope.row.index)" @change="qtyChange" style="width:70px" size="mini"></el-input>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="itemName"
                        width="265px"
                        align="left"
                        :label="$t('m.t_remarks')">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.remark" placeholder=""  auto-complete="off" @focus="getTempIndex(scope.row.index)" style="width:240px" size="mini"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="id"
                        align="center"
                        width="70"
                        :label="$t('m.b_opt')">
                    <template slot-scope="scope">
                        <el-button  size="mini" type="danger" @click="removeStockInItem(scope.row.index)"><i class="fa fa-trash "/></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-button style="margin-top: 10px;"type="primary" @click="addStockInItem" :loading="addEidtloading" size="small">{{$t('m.t_new')}}</el-button>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogAddsVisible = false">{{$t('m.b_cancel')}}</el-button>
                <el-button type="primary" @click="pendingListSave" :loading="addEidtloading">{{$t('m.b_save')}}</el-button>
            </div>
        </el-dialog>

        <!-- 編輯页面-->
        <el-dialog :title="dialogCodeName" :visible.sync="dialogCodeVisible" width="450px" :close-on-click-modal=false>
            <el-form  :model="pendingForm"  ref="pendingForm" label-width="160px" size="small">
                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item :label="$t('m.b_prodcode')+'：'" prop="itemName">
                            {{pendingForm.itemName}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item :label="$t('m.t_qtysk')+'：'" prop="qty">
                            <el-input v-model="pendingForm.qty" placeholder=""  auto-complete="off" style="width:200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="0">
                    <el-col :span="24">
                        <el-form-item :label="$t('m.t_remarks')+'：'" prop="remark">
                            <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 2, maxRows: 4}"
                                    placeholder=""
                                    v-model="pendingForm.remark" style="width:200px">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogCodeVisible = false">{{$t('m.b_cancel')}}</el-button>
                <el-button type="primary" @click="pendingSave" :loading="addEidtloading">{{$t('m.b_save')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios'
    import {getStockList,insertStockAdj,getStockAdjId,updateStockAdj,getItemAll,getValidateAdjustmentItemCode,addStockAdjustmentList,deleteStockAdjustment,getStockAdjustmentImport} from '../api/api'
    export default {
        data() {
            var validateItem=(rule, value, callback) => {
                let  pedId=this.pendingForm.id!=""?this.pendingForm.id:0;
                var params={id:pedId,itemId:value};
                return getValidateAdjustmentItemCode(params).then(data=>{
                    let item=data.data.data;
                    if(item==true){
                        callback(new Error(this.$t('m.m_untreated')));
                    }else {
                        callback();
                    }
                });
                callback();
            };
            var validateQty=(rule, value, callback) => {
                var reg= /^(-)?[1-9][0-9]*$/;
                if (value!=""&&value!=null){
                    if(!reg.test(value)){
                        callback(new Error(this.$t('m.m_numbernot0')));
                    }
                }
                callback();
            };
            return {
                pickerOptions0:{
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                //查詢條件
                serchCarNumber:"",
                serchStatus:'',
                getFeedDate:'',
                selectionItems:[],
                pager:{
                    page:0,
                    size:10,
                    total:0
                },
                stockAdjList:[],
                dialogName:'',
                tableloading:false,
                dialogAddsVisible:false,
                dialogCodeName:'',
                dialogAddsName:"",
                stockInList:[],
                index:0,
                selectIndex:0,
                addEidtloading:false,
                dialogCodeVisible:false,
                itemOptions:[],
                pendingForm:{
                    id:"",
                    itemId:"",
                    itemName:"",
                    qty:"",
                    storId:"",
                    shelfId:"",
                    cost:"",
                    status:0,
                    remark:""
                },
                pendingRules: {
                    itemId:[
                        {required: true, message: this.$t('m.m_producttype'), trigger: 'change' },
                        { validator: validateItem,trigger: 'change' }
                    ],
                    qty:[
                        {required: true, message:this.$t('m.m_number'), trigger: 'change' },
                        { validator: validateQty,trigger: 'change' }
                    ],
                    remark:[
                        {required: true, message: this.$t('m.m_remarks'), trigger: 'change' },
                    ]
                },
            }
        },
        methods: {
            importBnt(index,row){
                this.$confirm(this.$t('m.m_Importconfirm'), this.$t('m.m_info'), {
                    confirmButtonText: this.$t('m.t_confirm'),
                    cancelButtonText: this.$t('m.b_cancel'),
                    type: 'warning'
                }).then(() => {
                    var params = {id: row.id, token: this.$store.state.staff.token};
                    return getStockAdjustmentImport(params).then(data => {
                        if (data.data.data == true) {
                            this.$message.success(this.$t('m.m_Importsucs'));
                            this.getStockAdjustList();
                        } else {
                            this.$message.error("倉存數量不足以扣除！");
                        }
                    });
                });
            },
            pendingDel(index,row){
                this.$confirm(this.$t('m.m_deleteconfirm'), this.$t('m.m_info'), {
                    confirmButtonText: this.$t('m.t_confirm'),
                    cancelButtonText: this.$t('m.b_cancel'),
                    type: 'warning'
                }).then(() => {
                    deleteStockAdjustment(row.id).then(data=>{
                        let {errcode,errmsg}=data.data;
                        if(errcode==200){
                            this.$message.success(this.$t('m.m_deletesuc'));
                            this.getStockAdjustList();
                        }else{
                            this.$message.error(data.data.errmsg);
                        }
                    });
                })
            },
            handleSelect(val) {
                if (val!=''){
                    this.pendingForm.t_prodname=this.itemOptions.find(v=>v.id==val).itemName;
                }else {
                    this.pendingForm.t_prodname="";
                }
            },

            pendingSave(ev){
                if (!this.verifItemData()){
                    return;
                }

                var  params=Object.assign({},this.pendingForm);
                updateStockAdj(params).then(data=>{
                    this.addEidtloading=false;
                    let {errcode,errmsg}=data.data;
                    if(errcode==200){
                        this.$message.success(this.$t('m.m_updatesucs'));
                        this.getStockAdjustList();
                        this.resetForm("pendingForm");
                        this.dialogCodeVisible=false;
                    }else{
                        this.$message.error(data.errmsg);
                    }
                },err=>{
                    this.addEidtloading=false;
                });
            },
            pendingEdit(index,row){
                this.dialogCodeName=this.$t('m.t_editgoodsadjustment');
                this.dialogCodeVisible=true;
                this.pendingForm.itemName=this.stockAdjList[index].itemName;
                this.getStockAdjustmentById(row.id);
                this.resetForm("pendingForm");
            },
            getStockAdjustmentById(id){
                return getStockAdjId(id).then(data=>{
                    let item=data.data.data;
                    Object.assign(this.pendingForm,item);
                    //this.getItemOptions(this.pendingForm.itemName);
                });
            },
            pendingAdds(index,row){
                this.dialogAddsName=this.$t('m.t_addgoodsadjustment');
                this.dialogAddsVisible=true;
                this.index=0;
                this.stockInList=[];
                this.stockInItem={index:this.index,itemId:'',itemName:'',qty:'',remark:'',isShow:true,itemOptions:[],};
                this.stockInList.push(this.stockInItem);
            },
            getItemOptions(itemCode){
                getItemAll(itemCode).then(data=>{
                    this.itemOptions=data.data.data;
                });
            },
            pendingAdd(index,row){
                this.pendingForm={
                    id:"",
                    itemId:"",
                    itemName:"",
                    qty:"",
                    status:0,
                    remark:""
                };
                this.custOptions=[];
                this.dialogCodeName="新增货品调整";
                this.dialogCodeVisible=true;
                this.isShow=true;
                this.resetForm("pendingForm");
                this.getItemOptions();
            },
            getItemAllOption(value){
                if(value!=''){
                    return getItemAll(value).then(res=>{
                        if(res.data.errcode==200){
                            let {data:itemOption=[]}=res.data.data;
                            this.itemOptions = itemOption;
                        }else{
                            this.$message.error(res.data.errmsg);
                        }
                    }).catch((error)=>{
                        console.log("getItemAllOption Error");
                    })
                }
            },
            getItemListOption(value){
                if(value!=''){
                    getItemAll(value).then(res=>{
                        if(res.data.errcode==200){
                            this.stockInList[this.selectIndex].itemOptions = res.data.data;
                        }else{
                            this.$message.error(res.errmsg);
                        }
                    }).catch((error)=>{
                        console.log("getItemAllOption Error");
                    })
                }
            },
            querySearch(queryString, cb){
                if (queryString!=""){
                    getItemAll(queryString).then(data=>{
                        this.itemOptions=data.data.data==null?[]:data.data.data;
                        for(let i of this.itemOptions){
                            i.value = i.itemName;
                        };
                        let itemOptions = this.itemOptions;
                        var results = queryString?itemOptions.filter(this.createFilter(queryString)): itemOptions;
                        cb(results);
                    });
                }
            },
            pendingListSave(){
                if (!this.verifItemData()){
                    return;
                }
                this.pendingForm.itemListStr = this.getStockInListJson();
                var params = Object.assign({}, this.pendingForm);
                return addStockAdjustmentList(params).then(res=>{
                    if(res.data.errcode==200){
                        this.$message.success(this.$t('m.m_newgoodssuc'));
                        this.dialogAddsVisible=false;
                        this.getStockAdjustList();
                    }else{
                        this.$message.error(res.errmsg);
                    }
                }).catch((error)=>{
                    console.log("pendingListSave Error");
                })
            },
            getStockInListJson(){
                var jsonStr='[';
                for(var i =0;i<this.stockInList.length;i++){
                    jsonStr += '{';
                    jsonStr += "\"itemId\":\"" + this.stockInList[i].itemId+"\",";
                    jsonStr += "\"qty\":\"" + this.stockInList[i].qty+"\",";
                    jsonStr += "\"remark\":\"" + this.stockInList[i].remark+"\"";
                    jsonStr += '}'
                    jsonStr += ','
                }
                jsonStr = jsonStr.substring(0, jsonStr.length -1);
                jsonStr += ']';
                console.log(jsonStr);
                return jsonStr;
            },
            remarkChange(val){
                if(val.length>100){
                    this.$message.error(this.$t('m.m_lengthmin100'));
                    this.stockInList[this.selectIndex].remark="";
                }
            },
            qtyChange(val){
                var reg= /^(-)?[1-9][0-9]*$/;
                if (val!=""&&val!=null){
                    if(!reg.test(val)){
                        this.$message.error(this.$t('m.m_numbernot0'));
                        this.stockInList[this.selectIndex].qty="";
                    }else {
                        if (val<0){
                            this.stockInList[this.selectIndex].cost="";
                        }

                        if(val.length>6){
                            this.$message.error(this.$t('m.m_oversize'));
                            this.stockInList[this.selectIndex].qty="";
                        }

                    }
                }
            },
            itemHandleSelect(val){
                this.stockInList[this.selectIndex].itemName="";
                let  pedId=0;
                var params={id:pedId,itemId:val};
                getValidateAdjustmentItemCode(params).then(data=>{
                    let item=data.data;
                    if(item==true){
                        this.$message.warning(this.$t('m.m_untreated'));
                        this.rearrData();
                        pedId=1;
                    }
                });
                let i = 0;
                for(i=0;i<this.stockInList.length;i++){
                    if(i!=this.selectIndex&&this.stockInList[i].itemId==val){
                        pedId=2;
                    }
                }
                if (pedId==1){
                    return;
                }
                if (pedId==2){
                    this.$message.warning(this.$t("m.m_repeatedselection"));
                    //重置数据
                    this.rearrData();
                    return;
                }
                if (val!=''){
                    this.stockInList[this.selectIndex].itemName=this.stockInList[this.selectIndex].itemOptions.find(v=>v.id==val).itemName;
                }else {
                    this.stockInList[this.selectIndex].itemName="";
                }
            },
            rearrData(){
                this.stockInList[this.selectIndex].itemName="";
                this.stockInList[this.selectIndex].itemId="";
                this.stockInList[this.selectIndex].itemOptions=[];
                this.stockInList[this.selectIndex].isShow=true;
            },
            removeStockInItem(index){
                this.stockInList.splice(index,1);
                let i=0;
                for(i;i<this.stockInList.length;i++){
                    this.stockInList[0].index=i;
                }
                this.index=i-1;

            },
            getTempIndex(index){
                this.selectIndex=index;
            },
            verifItemData(){
                for (var item of  this.stockInList) {
                    if(item.itemId==""){
                        this.$message.error(this.$t("m.m_productchoice"));
                        return false;
                    }
                    if (item.qty==""){
                        this.$message.error(this.$t("m.m_number"));
                        return false;
                    }
                    if (item.remark==""){
                        this.$message.error(this.$t("m.m_remarks"));
                        return false;
                    }
                }
                return true;
            },
            addStockInItem(){
                if (!this.verifItemData()){
                    return;
                }
                this.stockInItem={index:this.index+=1,itemId:'',itemName:'',qty:'',remark:'',isShow:true,itemOptions:[]};
                this.stockInList.push(this.stockInItem);
            },
            handleSelectionFileChange(){},
            handleFileListChange(val){
            },

            custTaskPageChange(val){
                this.getStockAdjustList();
            },handleItemChange(val){
            },
            handleSelectionChange(val){
                this.selectionItems=val;
            },
            getStockAdjustList(){
                this.tableloading=true;
                var params={page:this.pager.page,size:this.pager.size,carNumber:this.serchCarNumber.trim(),feedDate:this.getFeedDate,status:this.serchStatus};
                if(params.feedDate!=null && params.feedDate!=''){
                    params.feedDate = parseInt(new Date(params.feedDate).getTime()/1000);
                }
                return getStockList(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode==200){
                        let {size,page,total,data:items=[]}=res.data;
                        this.stockAdjList=items;
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        this.tableloading=false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },

            resetForm(formName){
                if (this.$refs[formName]!==undefined) {
                    this.$refs[formName].resetFields();
                }
            }
        },
        mounted() {
        },
        activated(){
            this.getStockAdjustList();
        },
        computed: {
            canAdd(){
                return this.$store.getters.hasPermission("ADJUSTMENT_ADD");
            },
            canEdit(){
                return this.$store.getters.hasPermission("ADJUSTMENT__EDIT");
            },
            canDel(){
                return this.$store.getters.hasPermission("ADJUSTMENT__DEL");
            },
            canImport(){
                return this.$store.getters.hasPermission("ADJUSTMENT__IMPORT");
            }
        }
    }

</script>

<style lang="scss">
    .menu{
        .right{
            float: right;
        }
    }
    .el-tag + .el-tag {
        margin-left: 5px;
    }
    .dataListTable .cell{ white-space:nowrap; }
</style>



// WEBPACK FOOTER //
// src/views/StockAdjustMent.vue